import { FC } from 'react';
import { ModalComponent } from '.';

interface Props {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ChariotConfirmModal: FC<Props> = ({ isOpen, message, onConfirm, onCancel }) => (
  <ModalComponent isOpen={isOpen} closeModal={onCancel} contentClassName="chariot-confirm-modal">
    <span className="oath-eyebrow inkBlue">DAFPay Integration</span>
    <span className="oath-body inkBlue chariot-confirm-modal__message">{message}</span>
    <div className="chariot-confirm-modal__actions">
      <button type="button" className="btn-inkBlue btn btn-secondary" onClick={onConfirm}>
        Yes, proceed
      </button>
      <button
        type="button"
        className="oath-bodysmall link-text inkBlue padding0"
        onClick={onCancel}
      >
        No, cancel
      </button>
    </div>
  </ModalComponent>
);
